import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {  AngularEditorConfig  } from '@kolkov/angular-editor';
import * as $ from 'jquery';
import  *  as  helpData  from  '../../data/help/messaging.json';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';

//Model
import { Url } from '../../model/users.model';
import { Email } from '../../model/messaging.model';

//Service
import { MessagingService } from '../../services/messaging.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MessagingService ]

})


export class MessagingComponent implements OnInit {
  @LocalStorage() url: Url;

  error: any;
  loadingIndicator: boolean = true;
  messageType: number;
  recipientType: number;

  mailSent: boolean = false;
  
  pushSubject: string;
  pushMessage: string;
  smsMessage: string;

  public MESSAGE_TYPE = {
    PUSH: 1,
    SMS: 2,
    EMAIL: 3
  }

  public pushRecipientModel: string[];
  public pushRecipientSettings: IMultiSelectSettings = {
      enableSearch: true,
      checkedStyle: 'fontawesome',
      buttonClasses: 'btn btn-sm btn-secondary btn-block',
      dynamicTitleMaxItems: 1,
      displayAllSelectedText: true,
      showCheckAll: true,
      showUncheckAll: true
  };
  public pushRecipientTexts: IMultiSelectTexts = {
      checkAll: 'Select all',
      uncheckAll: 'Unselect all',
      checked: 'item selected',
      checkedPlural: 'items selected',
      searchPlaceholder: 'Find',
      defaultTitle: 'Select Drivers',
      allSelected: 'All selected',
  };

  public smsRecipientModel: string[];
  public smsRecipientSettings: IMultiSelectSettings = {
      enableSearch: true,
      checkedStyle: 'fontawesome',
      buttonClasses: 'btn btn-secondary btn-sm btn-block',
      dynamicTitleMaxItems: 3,
      displayAllSelectedText: true,
      showCheckAll: false,
      showUncheckAll: false,
      selectionLimit: 1,
      autoUnselect: true,
      closeOnSelect: true,
  };
  public smsRecipientTexts: IMultiSelectTexts = {
      checked: 'item selected',
      checkedPlural: 'items selected',
      searchPlaceholder: 'Find',
      defaultTitle: 'Select SMS Recipient',
      allSelected: 'All selected',
  };


  public pushRecipientOptions: IMultiSelectOption[];
  public smsRecipientOptions: IMultiSelectOption[];
  help: any;

  onlineDrivers: any[];
  smsAdmins : any[];
  smsDrivers: any[];
  smsRecipients: any[];
  mailForm: FormGroup;
  spinner: boolean = false;

  constructor(private http: HttpClient, private _mailer: FormBuilder,  private data: DataService, 
    private messagingService: MessagingService, private toastr: ToastrService) { 
    this.mailForm = this._mailer.group({
      recipient: ['', [Validators.required, Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,12},?)+$/)]],
      cc: [''],
      subject: [''],
      body: [''],
      attachment: this._mailer.array([])
    })

  }


  initFiles() {
    const group = this._mailer.group({
      file: [''],   
  });

  return group; 
  }

  getAttachmentControl() {
    const attCtrl = (<any>this.mailForm).controls.attachment;
    return attCtrl.controls;
}

addAttachment() {
  // add address to the list
  console.log('adding additional address');
  const control = (<any>this.mailForm).controls['attachment'];
 
  control.push(this.initFiles());
}

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '20',
      minHeight: '20',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter message here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'insertUnorderedList',
        'insertOrderedList',
      ],
      [
        'customClasses',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
};

  ngOnInit() {  

    $(document).ready(function() {

      $(".btn-info").click(function(){
          var html = $(".clone").html();
          $(".increment").after(html);
      });

      $("body").on("click",".btn-danger",function(){
          $(this).parents(".control-group").remove();
      });

    });

    this.http.get(this.url.rest  + '/tms/getMessagingData').subscribe(data => {
      this.onlineDrivers = data['online_drivers'];
      this.smsDrivers = data['sms_drivers'];
      console.log('drivers',this.smsDrivers);
      this.smsAdmins = data['sms_admin'];
      this.smsRecipients = this.smsAdmins.concat(this.smsDrivers);
      this.smsRecipients = this.smsDrivers;
      this.pushRecipientOptions = this.onlineDrivers;
      this.smsRecipientOptions = this.smsRecipients;

      console.log('SMS drivers: ',this.smsDrivers);
      setTimeout(() => { this.loadingIndicator = false; });
    });

    this.data.currentHelp.subscribe(help => this.help = help);
  }


  ngAfterViewInit() {
    setTimeout(() => { 	this.data.changeHelp(helpData["default"])});
	}

  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.mailForm.patchValue({
      avatar: file
    });
    this.mailForm.get('avatar').updateValueAndValidity()
  }

  setMessageType(type: number) {
    this.messageType = type;
    console.log(this.messageType);
  }

  getMessageType() {
    return this.messageType;
  }

  cancel() {
    this.setMessageType(null);

  }

  checkPushModel() {
    if (this.pushRecipientModel) {
      if (this.pushRecipientModel.length < 1)
        return false;
      else return true;
    }
    else return false;
   
  }

  checkPushMessage() {
    if (this.pushMessage) {
      if (this.pushMessage.length < 5)
        return false;
      else return true;
    }
    else return false;
   
  }

  checkSMSModel() {
    if (this.smsRecipientModel) {
      if (this.smsRecipientModel.length < 1)
        return false;
      else return true;
    }
    else return false;
   
  }

  checkSMSMessage() {
    if (this.smsMessage) {
      if (this.smsMessage.length < 1)
        return false;
      else return true;
    }
    else return false;   
  }

 async sendPush() {
    this.spinner = true;
    const pushData = {
        recipients: this.pushRecipientModel,
        subject: this.pushSubject,
        message: this.pushMessage
    };     
  
    console.log(pushData);
    
   await this.http.post(this.url.rest  + '/tms/sendPush', pushData, {responseType: 'json'}).toPromise().then(res => {
      
    });

   await this.messagingService.sendPush(pushData).toPromise().then( data => {
      if (data['error'] == false) {
        this.toastr.success('', 'Successfully sent the mobile notification.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
    
        // TODO: REFRESH THE BOOKING DETAILS
       
      } else 
          this.toastr.error("Please try again later.", "There was a problem with sending the message.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });

          // clear the email form
          this.pushRecipientModel = null;
          this.pushSubject = null;
          this.pushMessage = null;
          this.setMessageType(null);    
        
    }, error => {
      this.toastr.error("Please try again later.", "There was a problem with sending the message.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    })
    this.spinner = false;
  }  // end sendPush

  async sendSMS() {
  
    this.spinner = true;
    console.log("TRIAL",this.spinner);
    const smsData = {
        number: this.smsRecipientModel[0],
        message: this.smsMessage
    };     
    
    await this.messagingService.sendSMS(smsData).toPromise().then( data => {
      if (data['error'] == false) {
        this.toastr.success('', 'Successfully sent the SMS message.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
    
        // TODO: REFRESH THE BOOKING DETAILS
       
      } else 
          this.toastr.error("Please try again later.", "There was a problem with sending the message.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });

          // clear the email form
          this.setMessageType(null);    
          this.smsRecipientModel = null;
          this.smsMessage = null;
      
    }, error => {
      this.toastr.error("Please try again later.", "There was a problem with sending the message.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    })
    this.spinner = false;
  }  // end sendSMS


  async onSubmitEmail() {
    this.spinner = true;
    console.log('setting mailSent to true');
    this.mailSent = true;

    var mailData = new Email();
      mailData['to'] = this.mailForm.get('recipient').value,
      mailData.subject =  this.mailForm.get('subject').value,
      mailData.content =  this.mailForm.get('body').value

    console.log(mailData);
    await this.messagingService.sendEmail(mailData).toPromise().then( data => {
      if (data['error'] == false) {
        this.toastr.success('', 'Successfully sent the message.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
    
        // TODO: REFRESH THE BOOKING DETAILS
       
      } else 
          this.toastr.error("Please try again later.", "There was a problem with sending the message.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });

          // clear the email form
          this.setMessageType(null);    
          this.mailForm.reset();

    }, error => {
      this.toastr.error("Please try again later.", "There was a problem with sending the message.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    })
    this.spinner = false;
}
}